<template>
    <div>
        <el-form-item :label="$t('common.trackingNumber')" prop="trackingNumber">
            <el-input v-model="form.trackingNumber"></el-input>
        </el-form-item>
        <el-form-item :label="$t('orders.serviceOrderNumber')" prop="serviceOrderNumber">
            <el-input v-model="form.serviceOrderNumber"></el-input>
        </el-form-item>
        <el-form-item>
            <el-button type="primary" @click="submit">{{$t('common.save')}}</el-button>
        </el-form-item>
    </div>
</template>

<script>
export default {
  name: "tracking-info",
  props: {
    loading: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      form: {
        trackingNumber: "",
        serviceOrderNumber: ""
      },
      rules: {
        trackingNumber: [
          {
            required: true,
            message: this.$t('common.pleaseEnterTrackingNumber'),
            trigger: "blur"
          }
        ],
        serviceOrderNumber: [
          {
            required: true,
            message: this.$t('common.pleaseEnterServiceOrderNumber'),
            trigger: "blur"
          }
        ]
      }
    };
  },
  methods: {
    submit() {
      this.$refs["form"].validate(valid => {
        if (valid) {
          this.$emit("update", this.form);
        }
      });
    }
  }
};
</script>


// WEBPACK FOOTER //
// ClientApp/app/orders/components/TrackingInfo.vue